export default __webpack_public_path__ + "static/media/MTcarpaFull_Frente.a71f7bc0.webp";